import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgEvent = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.923 15.5H7v-2.077H4.923V15.5zm2.539 0h2.307v-2.077H7.462V15.5zm-2.539-2.538H7v-2.308H4.923v2.308zm2.539 0h2.307v-2.308H7.462v2.308zm-2.539-2.77H7V8.115H4.923v2.077zm5.308 5.308h2.307v-2.077h-2.307V15.5zm-2.77-5.308H9.77V8.115H7.462v2.077zM13 15.5h2.077v-2.077H13V15.5zm-2.77-2.538h2.308v-2.308h-2.307v2.308zM7.693 6.73V4.654a.237.237 0 0 0-.23-.23H7a.237.237 0 0 0-.23.23V6.73c0 .122.107.23.23.23h.462c.122 0 .23-.108.23-.23zM13 12.96h2.077v-2.307H13v2.308zm-2.77-2.769h2.308V8.115h-2.307v2.077zm2.77 0h2.077V8.115H13v2.077zm.23-3.461V4.654a.237.237 0 0 0-.23-.23h-.462a.237.237 0 0 0-.23.23V6.73c0 .122.108.23.23.23H13c.123 0 .23-.108.23-.23zM16 6.269V15.5a.93.93 0 0 1-.923.923H4.923A.93.93 0 0 1 4 15.5V6.27a.93.93 0 0 1 .923-.924h.923v-.692c0-.635.52-1.154 1.154-1.154h.462c.634 0 1.153.52 1.153 1.154v.692h2.77v-.692c0-.635.519-1.154 1.153-1.154H13c.635 0 1.154.52 1.154 1.154v.692h.923A.93.93 0 0 1 16 6.27z"
      />
    </svg>
  );
};
export default SvgEvent;
